"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaceOrderRequestedEvent = exports.Name = void 0;
const Name = exports.Name = 'place-order-requested';
const PlaceOrderRequestedEvent = exports.PlaceOrderRequestedEvent = Name;
//# sourceMappingURL=index.js.map